import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static readonly values = {
    toggleClass: String,
  };

  declare readonly toggleClassValue: string;
  declare readonly hasToggleClassValue: boolean;

  private readonly _defaultToggleClass = "collapsed";

  connect(): void {
    const isCollapsed = Boolean(sessionStorage.getItem("sidenavCollapsed"));
    if (isCollapsed) {
      this.element.classList.add(
        this.hasToggleClassValue
          ? this.toggleClassValue
          : this._defaultToggleClass
      );
    }
  }

  toggle() {
    this.element.classList.toggle(
      this.hasToggleClassValue
        ? this.toggleClassValue
        : this._defaultToggleClass
    );

    sessionStorage.setItem(
      "sidenavCollapsed",
      this.element.classList.contains(
        this.hasToggleClassValue
          ? this.toggleClassValue
          : this._defaultToggleClass
      )
        ? "1"
        : ""
    );
  }
}
